export const DEFAULT_LOCALE = 'pt-BR'
export const FALLBACK_LOCALE = 'pt-BR'
export const SUPPORTED_LOCALES = ['pt-BR', 'en', 'es'] as const
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

export const LOCALE_META: Record<SupportedLocale, { label: string; short: string; flag: string }> = {
  'pt-BR': { label: 'Português', short: 'PT', flag: '🇧🇷' },
  en: { label: 'English', short: 'EN', flag: '🇺🇸' },
  es: { label: 'Español', short: 'ES', flag: '🇪🇸' },
}

export const STORAGE_KEY = 'loczi.locale'

/** Normaliza qualquer BCP-47 para um locale suportado (pt, pt-BR, en-US, es-419…). */
export function normalizeLocale(input: string | null | undefined): SupportedLocale | null {
  if (!input) return null
  const tag = input.trim().toLowerCase().replace(/_/g, '-')
  if (tag.startsWith('pt')) return 'pt-BR'
  if (tag.startsWith('en')) return 'en'
  if (tag.startsWith('es')) return 'es'
  return null
}

export function readStoredLocale(): SupportedLocale | null {
  try {
    return normalizeLocale(globalThis.localStorage?.getItem(STORAGE_KEY))
  } catch {
    return null
  }
}

export function storeLocale(locale: SupportedLocale): void {
  try {
    globalThis.localStorage?.setItem(STORAGE_KEY, locale)
  } catch {
    /* private mode — ignora */
  }
}

/** Idioma inicial: armazenado > navegador > pt-BR (default oficial). */
export function detectInitialLocale(): SupportedLocale {
  const stored = readStoredLocale()
  if (stored) return stored

  const nav = globalThis.navigator
  for (const lang of nav?.languages ?? (nav?.language ? [nav.language] : [])) {
    const match = normalizeLocale(lang)
    if (match) return match
  }
  return DEFAULT_LOCALE
}
